import React from 'react';
import { MinusIcon, PlusIcon } from '@radix-ui/react-icons';

/** Contador − / + para vagas (0 a 30). */
const Stepper = ({ value, onChange, min = 0, max = 30, disabled = false, ariaLabel }) => {
  const v = Number.isFinite(Number(value)) ? Number(value) : 0;
  const set = (n) => onChange(Math.max(min, Math.min(max, n)));
  return (
    <div className={`esc-stepper ${disabled ? 'disabled' : ''}`}>
      <button type="button" onClick={() => set(v - 1)} disabled={disabled || v <= min} aria-label="menos">
        <MinusIcon />
      </button>
      <input
        type="number"
        min={min}
        max={max}
        value={v}
        disabled={disabled}
        aria-label={ariaLabel}
        onChange={(e) => set(e.target.value === '' ? 0 : parseInt(e.target.value, 10) || 0)}
      />
      <button type="button" onClick={() => set(v + 1)} disabled={disabled || v >= max} aria-label="mais">
        <PlusIcon />
      </button>
    </div>
  );
};

export default Stepper;
